var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('box',{staticClass:"has-padding-200"},[_c('p',{staticClass:"title has-text-centered"},[_vm._v(_vm._s(_vm.$t("_action.select_account")))]),_vm._v(" "),_c('select-account-list',{on:{"selected":_vm.selectAccount}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }